'use client';

import { useCheckout } from '../checkout-context';
import SignupForm from '@/components/signup-form';
import LoginForm from '@/components/login-form';
import ModernAuthStep from './modern-auth-step';

export default function AuthStep() {
  const { state, selectedPlan, handleAuthSuccess, toggleAuthMode, authSystem } = useCheckout();

  if (authSystem === 'modern') {
    return <ModernAuthStep />;
  }

  const planName = selectedPlan?.displayName || 'Penzu Pro';

  if (state.authMode === 'signup') {
    return (
      <div>
        <div className="mb-6">
          <h2 className="text-2xl font-bold font-merriweather mb-2">Create account</h2>
          <p className="text-sm text-slate-600">
            Sign up to experience <span className="font-semibold">{planName}</span>.
            <br />
            <span className="text-sm text-slate-600">Already have an account? </span>
            <button
              onClick={toggleAuthMode}
              className="text-sm text-blue-500 hover:text-blue-700 font-medium"
            >
              Log in here
            </button>
          </p>
        </div>
        <SignupForm onSuccess={handleAuthSuccess} hideHeader />
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold font-merriweather mb-2">Log in</h2>
        <p className="text-sm text-slate-600">
          Log in to continue with <span className="font-semibold">{planName}</span>
          <br />
          <span className="text-sm text-slate-600">Don&apos;t have an account? </span>
          <button
            onClick={toggleAuthMode}
            className="text-sm text-blue-500 hover:text-blue-700 font-medium"
          >
            Sign up
          </button>
        </p>
      </div>
      <LoginForm onSuccess={handleAuthSuccess} hideHeader />
    </div>
  );
}
